export default __webpack_public_path__ + "static/media/US.5ef04f41.svg";